<div class="advancedCFAccess__section">
  <h6 class="shareModalHeader">
    {{ 'flag' | ppTranslate }}

    <i
      ppTooltip
      [ppOptions]="{ placement: 'right' }"
      class="fa fa-info-circle settingsSection__header-info"
      aria-hidden="true"
      [ppTitle]="'flag_AAL_description' | ppTranslate"
      [ppMobileTooltip]="true"
    ></i>
  </h6>

  <pp-toggle
    [ppDisabled]="ppDisabled"
    ppId="toggleShowFlags"
    (ppAction)="correctProperty(EGoogleEventLabel.FLAG)"
    [ppChecked]="ppShare.advancedAccessLevels.flags.permission.edit"
    [ppReverseLayout]="true"
    ppStyle="blue"
  >
    <span class="toggleInnerText">{{ 'flag_points' | ppTranslate }}</span>
  </pp-toggle>
</div>
